import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FilterPanel = ({ filters, onFilterChange, onClearFilters, isOpen, onToggle }) => {
  const filterOptions = {
    type: [
      { value: 'whitepaper', label: 'Whitepapers', count: 12 },
      { value: 'calculator', label: 'Calculators', count: 5 },
      { value: 'video', label: 'Videos', count: 8 },
      { value: 'webinar', label: 'Webinars', count: 15 },
      { value: 'guide', label: 'Guides', count: 7 },
      { value: 'assessment', label: 'Assessments', count: 3 }
    ],
    role: [
      { value: 'C-Suite', label: 'C-Suite Executives', count: 18 },
      { value: 'Technical', label: 'Technical Leaders', count: 22 },
      { value: 'Procurement', label: 'Procurement', count: 8 },
      { value: 'Business', label: 'Business Units', count: 12 }
    ],
    industry: [
      { value: 'Healthcare', label: 'Healthcare', count: 8 },
      { value: 'Financial Services', label: 'Financial Services', count: 12 },
      { value: 'Manufacturing', label: 'Manufacturing', count: 6 },
      { value: 'Technology', label: 'Technology', count: 15 },
      { value: 'Retail', label: 'Retail', count: 4 },
      { value: 'Government', label: 'Government', count: 5 }
    ],
    pillar: [
      { value: 'AI Survival Strategy', label: 'AI Survival Strategy', count: 15 },
      { value: 'Open-Source Superiority', label: 'Open-Source Superiority', count: 18 },
      { value: 'Vendor Lock-in Risks', label: 'Vendor Lock-in Risks', count: 12 },
      { value: 'Internal Capability Building', label: 'Internal Capability Building', count: 20 }
    ]
  };

  const handleFilterToggle = (category, value) => {
    const currentFilters = filters?.[category] || [];
    const newFilters = currentFilters?.includes(value)
      ? currentFilters?.filter(item => item !== value)
      : [...currentFilters, value];
    
    onFilterChange(category, newFilters);
  };

  const getActiveFilterCount = () => {
    return Object.values(filters)?.reduce((total, filterArray) => total + filterArray?.length, 0);
  };

  return (
    <>
      {/* Mobile Filter Toggle */}
      <div className="lg:hidden mb-6">
        <Button
          variant="outline"
          fullWidth
          iconName="Filter"
          iconPosition="left"
          onClick={onToggle}
        >
          Filters {getActiveFilterCount() > 0 && `(${getActiveFilterCount()})`}
        </Button>
      </div>
      {/* Filter Panel */}
      <div className={`lg:block ${isOpen ? 'block' : 'hidden'} bg-white rounded-lg shadow-executive border border-gray-200 p-6 mb-6 lg:mb-0`}>
        <div className="flex items-center justify-between mb-6">
          <h3 className="text-lg font-semibold text-text-primary">Filters</h3>
          {getActiveFilterCount() > 0 && (
            <Button
              variant="ghost"
              size="sm"
              iconName="X"
              iconPosition="left"
              onClick={onClearFilters}
            >
              Clear All
            </Button>
          )}
        </div>

        <div className="space-y-6">
          {/* Content Type */}
          <div>
            <h4 className="font-medium text-text-primary mb-3 flex items-center">
              <Icon name="FileText" size={16} className="mr-2" />
              Content Type
            </h4>
            <div className="space-y-2">
              {filterOptions?.type?.map((option) => (
                <label key={option?.value} className="flex items-center cursor-pointer group">
                  <input
                    type="checkbox"
                    checked={filters?.type?.includes(option?.value) || false}
                    onChange={() => handleFilterToggle('type', option?.value)}
                    className="w-4 h-4 text-brand-primary border-gray-300 rounded focus:ring-brand-primary focus:ring-2"
                  />
                  <span className="ml-3 text-sm text-text-secondary group-hover:text-text-primary transition-colors duration-200">
                    {option?.label}
                  </span>
                  <span className="ml-auto text-xs text-text-secondary bg-gray-100 px-2 py-1 rounded-full">
                    {option?.count}
                  </span>
                </label>
              ))}
            </div>
          </div>

          {/* Target Role */}
          <div>
            <h4 className="font-medium text-text-primary mb-3 flex items-center">
              <Icon name="Users" size={16} className="mr-2" />
              Target Role
            </h4>
            <div className="space-y-2">
              {filterOptions?.role?.map((option) => (
                <label key={option?.value} className="flex items-center cursor-pointer group">
                  <input
                    type="checkbox"
                    checked={filters?.role?.includes(option?.value) || false}
                    onChange={() => handleFilterToggle('role', option?.value)}
                    className="w-4 h-4 text-brand-primary border-gray-300 rounded focus:ring-brand-primary focus:ring-2"
                  />
                  <span className="ml-3 text-sm text-text-secondary group-hover:text-text-primary transition-colors duration-200">
                    {option?.label}
                  </span>
                  <span className="ml-auto text-xs text-text-secondary bg-gray-100 px-2 py-1 rounded-full">
                    {option?.count}
                  </span>
                </label>
              ))}
            </div>
          </div>

          {/* Industry */}
          <div>
            <h4 className="font-medium text-text-primary mb-3 flex items-center">
              <Icon name="Building" size={16} className="mr-2" />
              Industry
            </h4>
            <div className="space-y-2">
              {filterOptions?.industry?.map((option) => (
                <label key={option?.value} className="flex items-center cursor-pointer group">
                  <input
                    type="checkbox"
                    checked={filters?.industry?.includes(option?.value) || false}
                    onChange={() => handleFilterToggle('industry', option?.value)}
                    className="w-4 h-4 text-brand-primary border-gray-300 rounded focus:ring-brand-primary focus:ring-2"
                  />
                  <span className="ml-3 text-sm text-text-secondary group-hover:text-text-primary transition-colors duration-200">
                    {option?.label}
                  </span>
                  <span className="ml-auto text-xs text-text-secondary bg-gray-100 px-2 py-1 rounded-full">
                    {option?.count}
                  </span>
                </label>
              ))}
            </div>
          </div>

          {/* Content Pillar */}
          <div>
            <h4 className="font-medium text-text-primary mb-3 flex items-center">
              <Icon name="Target" size={16} className="mr-2" />
              Content Pillar
            </h4>
            <div className="space-y-2">
              {filterOptions?.pillar?.map((option) => (
                <label key={option?.value} className="flex items-center cursor-pointer group">
                  <input
                    type="checkbox"
                    checked={filters?.pillar?.includes(option?.value) || false}
                    onChange={() => handleFilterToggle('pillar', option?.value)}
                    className="w-4 h-4 text-brand-primary border-gray-300 rounded focus:ring-brand-primary focus:ring-2"
                  />
                  <span className="ml-3 text-sm text-text-secondary group-hover:text-text-primary transition-colors duration-200">
                    {option?.label}
                  </span>
                  <span className="ml-auto text-xs text-text-secondary bg-gray-100 px-2 py-1 rounded-full">
                    {option?.count}
                  </span>
                </label>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterPanel;